import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';

const CurrentDocTotal = (props: GridCellProps) => {
  const { displayValue } = useGridCellDisplayValue(props);
  return <GridCellBase {...props}>{displayValue.trim() || 'N/A'}</GridCellBase>;
};

export default CurrentDocTotal;
